import { useNavigate } from "react-router-dom";
import StripePaymentVerification from "../../../components/StripePaymentVerification";
import { usePractitionerDetail } from "./hooks/usePractitionerDetail";
import { TEXTS } from "./constants";
import {
  LoadingContainer,
  LoadingSpinner,
  LoadingText,
  ErrorContainer,
  ErrorBox,
  ErrorTitle,
  ErrorDescription,
  NotFoundContainer,
  NotFoundBox,
  NotFoundTitle,
  PrimaryButton,
  PageWrapper,
} from "./styles";
import HeroSection from "./components/HeroSection";
import BookingStatusSection from "./components/BookingStatusSection";
import PersonalStorySection from "./components/PersonalStorySection";
import BiographySection from "./components/BiographySection";
import CredentialsSection from "./components/CredentialsSection";

const PractitionerDetail = () => {
  const navigate = useNavigate();
  const {
    isLoading,
    reduxError,
    userFromState,
    clinicPractitioner,
    practitionerData,
    patientData,
    assigningContact,
    error,
    setError,
    calendarWindowRef,
    checkingPayment,
    paymentVerified,
    savedCardInfo,
    showPaymentModal,
    setShowPaymentModal,
    handleOpenCalendarInNewTab,
    handleBackNavigation,
    handlePaymentVerificationSuccess,
  } = usePractitionerDetail();

  if (isLoading) {
    return (
      <LoadingContainer>
        <LoadingSpinner />
        <LoadingText>{TEXTS.loading}</LoadingText>
      </LoadingContainer>
    );
  }

  if (reduxError) {
    return (
      <ErrorContainer>
        <ErrorBox>
          <ErrorTitle variant="h4">{TEXTS.error.title}</ErrorTitle>
          <ErrorDescription>
            {reduxError.message || TEXTS.error.description}
          </ErrorDescription>
          <PrimaryButton variant="contained" onClick={() => navigate(-1)}>
            {TEXTS.error.button}
          </PrimaryButton>
        </ErrorBox>
      </ErrorContainer>
    );
  }

  if (!userFromState && !clinicPractitioner) {
    return (
      <NotFoundContainer>
        <NotFoundBox>
          <NotFoundTitle variant="h4">{TEXTS.notFound.title}</NotFoundTitle>
          <PrimaryButton variant="contained" onClick={() => navigate(-1)}>
            {TEXTS.notFound.button}
          </PrimaryButton>
        </NotFoundBox>
      </NotFoundContainer>
    );
  }

  return (
    <>
      <PageWrapper className="homepage">
        <HeroSection
          practitionerData={practitionerData}
          onBack={handleBackNavigation}
          checkingPayment={checkingPayment}
          paymentVerified={paymentVerified}
          savedCardInfo={savedCardInfo}
          onBookClick={handleOpenCalendarInNewTab}
          assigningContact={assigningContact}
        />

        <BookingStatusSection
          assigningContact={assigningContact}
          practitionerName={practitionerData.fullName}
          calendarWindowRef={calendarWindowRef}
          error={error}
          onCloseError={() => setError(null)}
        />

        <PersonalStorySection personalStory={practitionerData.personalStory} />

        <BiographySection
          fullBio={practitionerData.fullBio}
          bio={practitionerData.bio}
          firstName={practitionerData.firstName}
          fullName={practitionerData.fullName}
        />

        <CredentialsSection practitionerData={practitionerData} />
      </PageWrapper>

      <StripePaymentVerification
        open={showPaymentModal}
        onClose={() => setShowPaymentModal(false)}
        onVerificationSuccess={handlePaymentVerificationSuccess}
        patientEmail={patientData?.email}
        patientData={patientData}
      />
    </>
  );
};

export default PractitionerDetail;
